import { useListPrompts, type PlainPrompt } from "@/queries/agent-queries";
import { useMemo } from "react";

export type ReviewSkill = {
    id: string;
    label: string;
    /** The slash command to invoke, e.g. "review-like-anton" */
    command: string;
};

/**
 * Fetches organization-level prompts whose name contains "review like"
 * and returns them as ReviewSkill entries for the Review button dropdown.
 */
export function useReviewSkills() {
    const { data, isPending } = useListPrompts({
        isCommand: true,
        excludePromptContent: true,
        search: "review like",
    });

    const skills = useMemo(() => {
        if (!data?.prompts) return [];

        return data.prompts
            .filter((p: PlainPrompt) => {
                const name = p.metadata?.name?.toLowerCase() ?? "";
                return name.includes("review like") && p.spec?.command;
            })
            .map(
                (p: PlainPrompt): ReviewSkill => ({
                    id: p.id,
                    label: p.metadata?.name ?? `/${p.spec?.command}`,
                    command: p.spec!.command,
                }),
            )
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [data?.prompts]);

    return { skills, isPending };
}
